if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.cards').slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });

    //History block years slider
    // $('.history-block__years-slider').slick({
    //     dots: false,
    //     vertical: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     //verticalSwiping: true,
    //     asNavFor: ".history-block__content",
    //     prevArrow: $('.arrows-history .btn-prev'),
    //     nextArrow: $('.arrows-history .btn-next'),
    //     infinite: false,
    //     responsive: [
    //         {
    //             breakpoint: 575,
    //             settings: {
    //                 adaptiveHeight: true
    //             }
    //         }
    //     ]
    // });

    //History block years content
    // $('.history-block__content--years').slick({
    //     dots: false,
    //     vertical: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     verticalSwiping: true,
    //     asNavFor: ".history-block__years-slider",
    //     infinite: false
    // });

    // $('.history-block__content--text').slick({
    //     dots: false,
    //     vertical: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     infinite: false,
    //     asNavFor: ".history-block__years-slider",
    //     infinite: false,
    //     verticalSwiping: true
    // });

    //Gallery slider
    $('.gallery-block__slider').slick({
        dots: false,
        slidesToShow: 4,
        variableWidth: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    variableWidth:false
                }
            }
        ]
    });

    $('.js-tabs-slider').slick({
      customPaging : function(slider, i) {
        return $(slider.$slides[i]).data('tab');
      },
      dots: true,
      appendDots: '.js-tabs-paging',
      adaptiveHeight: true,
      fade: true,
      draggable: false
    });
    
    setTimeout(() => {
      // Obtener el enlace
      let hashPent = window.location.hash.substring(1)
      if(hashPent == "Penthouse"){
        const penthouse = document.getElementById("Penthouse");
        penthouse.click(); // Simula el clic
      }
    }, 2000);

})();